import styled from "styled-components";
import { device } from "../../utils/helpers/breakpoints";

export const DocumentCardContainer = styled.div`
  display: flex;
  cursor: pointer;
  border: 1px solid grey;
  border-radius: 1rem;
  padding: 1rem;
  min-width: 15rem;
  justify-content: center;
  &:hover {
    background: #1a5304;
    color: #fff;
  }
  @media ${device.tablet} {
    min-width: 100%;
  }
`;